
import { rxRoute } from "../../../../helpers/formatting";

export function getBSWPharmacy(props) {
    const { hasPharmacyLogin, isProxyUser, currentPharmacyUser, rxDown, bundle } = props;
    const isMyChartProxyUser = isProxyUser;
    const showMenuItem = (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser;
    return {
        icon: 'icon-pharmacy',
        show: (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser,
        disabled: rxDown,
        navHead: {
            label: 'BSW Pharmacy',
            url: null
        },
        navItems: [
            {
                label: 'Home',
                show: (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser,
                url: (typeof window !== "undefined" && bundle !== 'pharmacy' && window.location.href.toLowerCase().indexOf('localhost') > -1) ? '/pharmacy' : '/rxHome',
                subMenuItems: null
            },
            {
                label: 'Prescriptions',
                show: (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser,
                url: rxRoute('rxList'),
                altUrls: ['/rxdetail', '/pharmacyrxdetail'],
                subMenuItems: null
            },
            {
                label: 'Order a Refill',
                show: (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser,
                url: rxRoute('rxRefill'),
                subMenuItems: null
            },
            {
                label: 'Transfer',
                show: (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser,
                url: rxRoute('rxTransfer'),
                altUrls: ['/nonbswtransfer', '/bswtransfer', '/pharmacynonbswtransfer', '/pharmacybswtransfer'],
                subMenuItems: null
            },
            {
                label: 'Find a Pharmacy',
                show: (hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser,
                url: rxRoute('findPharmacy'),
                subMenuItems: null
            }
        ]
    };
}